import { z } from 'zod';

/**
 * Schema dos env vars expostos via Vite (`import.meta.env`).
 * Tudo que começa com `VITE_` é serializado no bundle — NUNCA coloque
 * segredos aqui.
 *
 * Vars que faltam ou estão malformadas explodem na carga do módulo —
 * preferimos crash rápido em dev a bug silencioso em prod.
 */
const envSchema = z.object({
  /**
   * Base URL da API .NET. Em dev usa proxy do Vite (`/api` → localhost:5145),
   * então o default `/api/v1` funciona sem CORS.
   * Em prod, configure VITE_API_BASE_URL no build — o workflow
   * .github/workflows/deploy-frontend.yml injeta
   * `https://www.api.report.amvoxtech.com.br/api/v1`.
   */
  VITE_API_BASE_URL: z.string().default('/api/v1'),

  /** Modo do Vite — populado automaticamente. */
  MODE: z.enum(['development', 'production', 'test']).default('development'),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
   
  console.error('❌ Env vars inválidas:', parsed.error.flatten().fieldErrors);
  throw new Error('Configuração de ambiente inválida — veja console.');
}

export const env = parsed.data;
